// @mui
import { Typography, Box, Paper, Button } from '@mui/material';
// components
import Image from '../../components/Image';
import { MotionInView, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

const CATEGORIES = [
  {
    label: 'Promotional materials (coming soon)',
    icon: 'https://img.magnific.com/free-vector/flat-design-ambassador-illustration_52683-85736.jpg',
    href: '#',
    // href: 'https://drive.google.com/file/d/1SQVJJgPEzJBYIrU0s9JqMtOhms7UasMv/view?usp=drive_link',
  },
//   {
//     label: 'How to prepare a Bible study for small groups',
//     icon: 'https://i.ibb.co/LRhws3V/teach.jpg',
//     href: '#',
//   },
//   {
//     label: 'How to apply the Bible faithfully in their lives',
//     icon: 'https://i.ibb.co/RYdFKNK/apply.jpg',
//     href: '#',
//   },
//   {
//     label: 'Practical ministry skills',
//     icon: 'https://i.ibb.co/tX0FKQB/practical.jpg',
//     href: '#',
//   },
];

// ----------------------------------------------------------------------

export default function ResourcesList() {
  return (
    <Box
      sx={{
        mb: 15,
        display: 'grid',
        gap: 3,
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(4, 1fr)',
        },
      }}
    >
      {CATEGORIES.map((category) => (
        <MotionInView key={category.label}>
          <CategoryCard category={category} />
        </MotionInView>
      ))}
    </Box>
  );
}

// ----------------------------------------------------------------------

type CategoryCardProps = {
  category: {
    label: string;
    icon: string;
    href: string;
  };
};

function CategoryCard({ category }: CategoryCardProps) {
  const { label, icon, href } = category;

  return (
    <Paper
      variant="outlined"
      sx={{
        px: 2,
        height: 260,
        border: 'none',
        borderRadius: 2,
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        // '&:hover': {
        //   boxShadow: (theme) => theme.customShadows.z24,
        // },
      }}
    >
      <Image src={icon} sx={{ mb: 2, width: 150, height: 120 }} />
      <Typography sx={{ fontSize: 19 }}>
        {label} 
      </Typography>
      <Button sx={{ mt: 2 }} variant="contained" color="primary" href={href} target="_blank">View</Button>
    </Paper>
  );
}
